var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return !_vm.closed
    ? _c(
        "div",
        {
          class: _vm.classNames
        },
        [
          _c(
            "div",
            {
              staticClass: "messagebox_buttons"
            },
            [
              _vm.hideDetails
                ? _c(
                    "a",
                    {
                      staticClass: "details",
                      attrs: {
                        href: "",
                        title: _vm.$gettext("Detailanzeige umschalten")
                      },
                      on: {
                        click: function click($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          _vm.closedDetails = !_vm.closedDetails
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$gettext("Detailanzeige umschalten")))
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideClose
                ? _c(
                    "a",
                    {
                      staticClass: "close",
                      attrs: {
                        href: "",
                        title: _vm.$gettext("Nachrichtenbox schließen")
                      },
                      on: {
                        click: function click($event) {
                          $event.preventDefault()
                          _vm.closed = true
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$gettext("Nachrichtenbox schließen")))
                      ])
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _vm.showDetails
            ? _c(
                "div",
                {
                  staticClass: "messagebox_details"
                },
                [
                  _vm._t("details", [
                    _c(
                      "ul",
                      _vm._l(_vm.details, function(detail) {
                        return _c("li", {
                          domProps: {
                            innerHTML: _vm._s(detail)
                          }
                        })
                      }),
                      0
                    )
                  ])
                ],
                2
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }